// import { LoginRes } from "@/types/dto/loginRes";
import { commonGetData, createExceptionRes, createResBlobFromResponse, createResFromResponse } from "./common";
import { getData, getFile, patchData, postData } from "./client_utils";
import { FetchSchoolsParam, SchoolsResource } from "../dto/SchoolsResource";
import { AdvisoryRequest, AdvisoryResponse, CostsResponse } from "../dto/Advisory";
import { ProfessionsResource } from "../dto/ProfessionsResource.ts";
import { FetchSchoolCoursesParam, SchoolCoursesResource } from "../dto/SchoolCoursesResource";
import {
    FetchSchoolCourseTypesParam,
    SCHOOL_COURSE_TYPE_HS,
    SCHOOL_COURSE_TYPE_LT,
    SCHOOL_COURSE_TYPE_LM,
    SCHOOL_COURSE_TYPE_LMCU,
    SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO,
    SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO,
    SCHOOL_COURSE_TYPE_PHD,
    SCHOOL_COURSE_TYPE_BACHELOR,
    SCHOOL_COURSE_TYPE_MASTER_ESTERO,
    SCHOOL_COURSE_TYPE_CORSO_ITS,
    SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL,
    degreeTypeLabels,
    DegreeType,
    degreeTypeOrder
} from "../dto/SchoolCourseTypesResource";
import { AnswersRequest, ExecutionRequest, ExecutionResponse } from "../dto/Executions";
import { ProfessionsNewVersionResource } from "../dto/ProfessionsNewVersionResource";
import { CertificationsResponse } from "@/generated/@habacus/certification_api/src/models";
import { CertificationsRequest } from "../dto/CertificationRequest";
import { IndexesResponse } from "../dto/Indexes";
import { LeadReq, LeadResp } from "@/types/typesInterfaces";


export interface PaymentCreateRequest {
    amountPaid: number;
    billingUuid?: string;
    clientUuid?: string;
}

export interface PaymentCreateResponse {
    paymentToken?: string;
    paymentID?: string;
    userRedirect?: {
        href?: string
    }
}
export interface PaymentCreateCartItemRequest {
    itemUuid?: string;
    amount?: number;
}
export interface PaymentCreateCartRequest {
    items: PaymentCreateCartItemRequest[]
    clientUuid: string
}

export interface PaymentCreateCartResponse {
    uuid: string;
    amountDue: number;
}

export interface PaymentGetCatalogItem {
    uuid: string;
    name: string;
    description?: string;
    vendorName?: string;
    typologyName?: string;
    unitCost?: number;
    recurringCost?: number;
    taxRate?: number;
}

const BASE_API = () => {
    try {
        return `${window.location.protocol}//${window.location.host}`;
    } catch (error) {
        return process.env.BASE_URL!;
    }
}

const API_GET_PROFESSIONS = () => `${BASE_API()}/api/professions`;
const API_GET_PROFESSIONS_BY_AREA = () => `${BASE_API()}/api/professions_by_area`;
const API_GET_SCHOOLS = () => `${BASE_API()}/api/schools`;
const API_GET_SCHOOL_COURSES = () => `${BASE_API()}/api/school_courses`;
const API_CREATE_ADVISORY = () => `${BASE_API()}/api/advisory`;
const API_ADVISORY_HEALTH_CHECK = () => `${BASE_API()}/api/advisory_health_check`;
const API_CREATE_CERTIFICATIONS = () => `${BASE_API()}/api/certifications`;
const API_CERTIFICATIONS_HEALTH_CHECK = () => `${BASE_API()}/api/certifications_health_check`;
const API_GET_LIFECOST = () => `${BASE_API()}/api/costs`;
const API_LIFECOST_HEALTH_CHECK = () => `${BASE_API()}/api/costs_health_check`;

const API_DOWNLOAD_PDF = () => `${BASE_API()}/api/download_pdf`;
const API_INDEXES = () => `${BASE_API()}/api/indexes`;

const API_EXECUTION_CREATE_ANSWERS = () => `${BASE_API()}/api/data_storage/answers`;
const API_EXECUTION_SET_COSTS = () => `${BASE_API()}/api/data_storage/costs`;
const API_EXECUTION_SET_CERTIFICATIONS = () => `${BASE_API()}/api/data_storage/certifications`;
const API_EXECUTION_CREATE = () => `${BASE_API()}/api/data_storage/executions`;
const API_EXECUTION_SET_PATHS = () => `${BASE_API()}/api/data_storage/paths`;
const API_EXECUTION_SET_PATH_CHOOSEN = () => `${BASE_API()}/api/data_storage/path_choosen`;


const API_LEAD_CREATE = () => `${BASE_API()}/api/leads`;
const API_PAYMENT_CREATE = () => `${BASE_API()}/api/payments/payment`;
const API_PAYMENT_POST_CART = () => `${BASE_API()}/api/payments/cart`;
const API_PAYMENT_CREATE_CLIENT = () => `${BASE_API()}/api/payments/client`;
const API_PAYMENT_GET_CATALOG_ITEM = () => `${BASE_API()}/api/payments/catalog`;
const API_PAYMENT_GET_INVENTORY = () => `${BASE_API()}/api/payments/inventory`;


const API_CSRF_GET = () => `${BASE_API()}/api/csrf`;

const API_REGISTRATION = () => `${BASE_API()}/api/registration`;
const API_BFF = () => `${BASE_API()}/api/bff`;
const API_CONSENT = () => `${BASE_API()}/api/consent`;
const API_ACCOUNT = () => `${BASE_API()}/api/account`;
const API_STUDENT = () => `${BASE_API()}/api/student`;
const API_LOGIN = () => `${BASE_API()}/api/login`;
const API_LOGOUT = () => `${BASE_API()}/api/logout`;

const API_RECAPTCHA = () => `${BASE_API()}/api/recaptcha`;

const API_GET_FIREBASE_CONFIG = () => `${BASE_API()}/api/firebase`;

export const getFirebaseConfig = async () => {
    try {
        const res = await commonGetData(false, {}, API_GET_FIREBASE_CONFIG(), null, 180);
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchSchoolsWithPaginate = async (param: FetchSchoolsParam) => {
    // mandare all'algoritmo id, nome, typologia, address
    // nel caso di scelta ente  a_mano aggiungere address (di google)
    try {
        const res = await getData(API_GET_SCHOOLS(), {
            page: param.page,
            per_page: param.per_page,
            query_search: param.query_search,
            school_typologies: param.school_typologies,
            course_typologies: param.course_typologies,
        })
        return await createResFromResponse<SchoolsResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchCsrf = async () => {
    try {
        const res = await getData(API_CSRF_GET())
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}


export const fetchSchoolCoursesWithPaginate = async (param: FetchSchoolCoursesParam) => {
    try {
        const res = await getData(API_GET_SCHOOL_COURSES(), {
            page: param.page,
            per_page: param.per_page,
            query_search: param.query_search,
            school_id: param.school_id,
            course_types: param.course_types,
        })
        return await createResFromResponse<SchoolCoursesResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchSchoolCourseTypesWithPaginate = async (param: FetchSchoolCourseTypesParam) => {
    try {
        await new Promise(f => setTimeout(f, 1000));

        const typeOptions: DegreeType[] = [
            SCHOOL_COURSE_TYPE_HS,
            SCHOOL_COURSE_TYPE_CORSO_ITS,
            SCHOOL_COURSE_TYPE_LT,
            SCHOOL_COURSE_TYPE_LM,
            SCHOOL_COURSE_TYPE_LMCU,
            SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO,
            SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO,
            SCHOOL_COURSE_TYPE_PHD,
            SCHOOL_COURSE_TYPE_BACHELOR,
            SCHOOL_COURSE_TYPE_MASTER_ESTERO,
            SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL
        ];

        const options: any[] = [];

        typeOptions.forEach((value: DegreeType) => options.push({ 'id': value, 'name': degreeTypeLabels[value], 'order': degreeTypeOrder[value] }));

        options.sort((a: any, b: any) => a.order >= b.order ? 1 : 0);

        return {
            statusCode: 200,
            isOk: true,
            response: {
                school_course_types: options,
                page: 1,
                total_count: options.length,
            },
            error: null,
        }
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchProfessionsWithPaginate = async (locale: string, page: number, per_page: number, value: string) => {
    try {
        const res = await getData(API_GET_PROFESSIONS(), {
            lang: locale,
            page: page,
            per_page: per_page,
            value: value
        })

        return await createResFromResponse<ProfessionsResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}
export const fetchProfessionsByAreaWithPaginate = async (locale: string, page: number, per_page: number, value: string, sector: string | null) => {
    try {
        const res = await getData(API_GET_PROFESSIONS_BY_AREA(), {
            lang: locale,
            page: page,
            per_page: per_page,
            value: value,
            sector: sector
        })

        return await createResFromResponse<ProfessionsNewVersionResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const createAdvisory = async (
    data: AdvisoryRequest
) => {
    try {

        const res = await postData(API_CREATE_ADVISORY(), data);
        return await createResFromResponse<AdvisoryResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const advisoryHealthCheck = async () => {
    try {
        const res = await getData(API_ADVISORY_HEALTH_CHECK());
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const createCertifications = async (
    data: CertificationsRequest
) => {
    try {

        const res = await postData(API_CREATE_CERTIFICATIONS(), data);
        return await createResFromResponse<CertificationsResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const certificationsHealthCheck = async () => {
    try {
        const res = await getData(API_CERTIFICATIONS_HEALTH_CHECK());
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const downloadPdf = async () => {
    try {
        const response = await getFile(API_DOWNLOAD_PDF());

        if (!response.ok) {
            throw new Error(`Errore nel download del PDF: ${response.statusText}`);
        }

        return await createResBlobFromResponse(response);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const getLifeCost = async (
    city: string | null,
    country?: string | null,
) => {
    try {
        const res = await getData(API_GET_LIFECOST(), {
            city: city,
            country: country
        });
        return await createResFromResponse<CostsResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}
export const getIndexes = async () => {
    try {
        const res = await getData(API_INDEXES());

        return await createResFromResponse<IndexesResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const lifeCostHealthCheck = async () => {
    try {
        const res = await getData(API_LIFECOST_HEALTH_CHECK());
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const createExecution = async (data?: ExecutionRequest) => {
    try {
        const res = await postData(API_EXECUTION_CREATE(), data);
        return await createResFromResponse<ExecutionResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const updateExecution = async (data?: ExecutionRequest) => {
    try {
        const res = await patchData(API_EXECUTION_CREATE(), data);
        return await createResFromResponse<ExecutionResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const createAnswers = async (data?: AnswersRequest) => {
    try {
        const res = await postData(API_EXECUTION_CREATE_ANSWERS(), data);
        return await createResFromResponse<null>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const setExecutionPaths = async (data: any) => {
    try {
        const res = await postData(API_EXECUTION_SET_PATHS(), data);
        return await createResFromResponse<null>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const setExecutionPathChoosen = async (data: any) => {
    try {
        const res = await postData(API_EXECUTION_SET_PATH_CHOOSEN(), {
            "path": data,
            "source": "generated",
        });
        return await createResFromResponse<null>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const setExecutionCosts = async (data: any, source: string) => {
    try {
        const res = await postData(API_EXECUTION_SET_COSTS(), {
            "costs": data,
            "source": source,
        });
        return await createResFromResponse<null>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const setExecutionCertifications = async (data: any) => {
    try {
        const res = await postData(API_EXECUTION_SET_CERTIFICATIONS(), {
            "certifications": data,
            "source": "generated",
        });
        return await createResFromResponse<null>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const performLogout = async () => {
    try {
        const res = await postData(API_LOGOUT());
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const performRecaptcha = async (token: string) => {
    try {
        const res = await postData(API_RECAPTCHA(), { token });
        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("Login failed", e);
        return createExceptionRes(e);
    }
}

export const performLogin = async (email: string, token: string, csrfToken: string, recaptchaToken: string) => {
    try {
        const res = await postData(API_LOGIN(), { email: email, csrfToken: csrfToken, recaptchaToken: recaptchaToken });

        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("Login failed", e);
        return createExceptionRes(e);
    }
}

export const performRegistration = async (name: string, surname: string, taxCode: string, email: string, password: string, consentStates: any, token: string) => {
    try {
        const res = await postData(API_REGISTRATION(), {
            name: name,
            surname: surname,
            taxCode: taxCode,
            email: email,
            consentStates: consentStates,
        });

        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("Registration failed", e);
        return createExceptionRes(e);
    }
}

export const performConsent = async (lang: string, anonymousToken: string) => {
    try {
        const res = await commonGetData(false,
            { 'Authorization': 'Bearer ' + anonymousToken },
            API_CONSENT(),
            { lang: lang }
        );
        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("get consent failed", e);
        return createExceptionRes(e);
    }
}
export const performGetAccount = async (email?: string, token?: string) => {
    try {
        const res = await getData(
            API_ACCOUNT(),
            { email: email }
        );
        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("get account failed", e);
        return createExceptionRes(e);
    }
}

export const performGetStudent = async (accountUuid: string) => {
    try {
        const res = await getData(API_STUDENT(), {
            accountUuid: accountUuid
        })
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const leadCreate = async (data: LeadReq) => {
    try {
        const res = await postData(API_LEAD_CREATE(), data);
        return await createResFromResponse<LeadResp>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const paymentCreate = async (data: PaymentCreateRequest) => {
    try {
        const res = await postData(API_PAYMENT_CREATE(), data);
        return await createResFromResponse<PaymentCreateResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const paymentCreateCart = async (data: PaymentCreateCartRequest) => {
    try {
        const res = await postData(API_PAYMENT_POST_CART(), data);
        return await createResFromResponse<PaymentCreateCartResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const paymentGetCatalogItem = async (tenant: string) => {
    try {
        const res = await getData(API_PAYMENT_GET_CATALOG_ITEM(), { tenant: tenant });
        return await createResFromResponse<PaymentGetCatalogItem>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const paymentCreateClient = async (uuid: string, taxCode: string, name: string, surname: string, email: string) => {
    try {
        const res = await postData(API_PAYMENT_CREATE_CLIENT(), {
            uuid: uuid,
            taxCode: taxCode,
            name: name,
            surname: surname,
            email: email
        });
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const paymentGetInventory = async (clientUuid: string, itemUuid: string) => {
    try {
        const res = await getData(API_PAYMENT_GET_INVENTORY(), {
            clientUuid: clientUuid,
            itemUuid: itemUuid
        });
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}
